import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';

const OrganizationsFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);
  const { travelAgency } = useSelector((store) => store.user);
  const options = travelAgency && travelAgency.organizations
    ? travelAgency.organizations.map((org) => ({ label: org.value, value: org.value }))
    : [];

  const handleCruisePayment = useCallback((selectedOptionsValue) => {
    const selectedOrganization = selectedOptionsValue && selectedOptionsValue;
    const searchObj = {
      ...tripsSearch.searchObj,
      organizations: selectedOrganization,
      page: 1,
    };
    onSearch(searchObj, tripsSearch.searchObj);
  }, [onSearch, tripsSearch]);

  return (
    options.length === 0 ? <></>
      : (
        <CheckboxSelectFilter
          options={options}
          values={tripsSearch.searchObj.organizations ? tripsSearch.searchObj.organizations : []}
          onChange={handleCruisePayment}
          label="Organization"
          widthInside="max-w-85"
          variant="outline"
          filterMaxWidthClass="max-w"
        />
      )
  );
};

OrganizationsFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default OrganizationsFilter;
